// extracted by mini-css-extract-plugin
export var footer = "_p7-5";
export var fulfillmentInput = "_p7-0";
export var shipDateInput = "_p7-1";
export var shipmentModal = "_p7-2";
export var shipmentModalContent = "_p7-3";
export var tableContainer = "_p7-4";